import React, { createContext, useContext, useState, useEffect } from 'react';

const BRANDS = {
  "saketh.ai": {
    id: "saketh.ai",
    name: "Saketh.ai",
    tagline: "AI Voice Agents Platform",
    primary: "#8B5CF6",
    secondary: "#7C3AED",
    accent: "#4C1D95",
    gradient: "linear-gradient(135deg, #8B5CF6 0%, #4C1D95 100%)",
    heroImage: "https://images.unsplash.com/photo-1741795990583-d4115c018da2"
  },
  "sakethacademy.com": {
    id: "sakethacademy.com",
    name: "Saketh Academy",
    tagline: "Learn Future Tech Skills",
    primary: "#10B981",
    secondary: "#059669",
    accent: "#047857",
    gradient: "linear-gradient(135deg, #3B82F6 0%, #10B981 100%)",
    heroImage: "https://images.unsplash.com/photo-1765445666678-e1e7231962d5"
  },
  "marketmindpro.io": {
    id: "marketmindpro.io",
    name: "MarketMind Pro",
    tagline: "AI Trading Signals",
    primary: "#EF4444",
    secondary: "#DC2626",
    accent: "#B91C1C",
    gradient: "linear-gradient(135deg, #111827 0%, #1F2937 100%)",
    heroImage: "https://images.unsplash.com/photo-1639825752750-5061ded5503b"
  },
  "ailaw.me": {
    id: "ailaw.me",
    name: "AILaw / Optimo AI",
    tagline: "Legal Automation Platform",
    primary: "#3B82F6",
    secondary: "#2563EB",
    accent: "#1E40AF",
    gradient: "linear-gradient(135deg, #1E293B 0%, #0F172A 100%)",
    heroImage: "https://images.unsplash.com/photo-1589578527966-fdac0f44566c"
  },
  "optimoai.io": {
    id: "optimoai.io",
    name: "OptimoAI.io",
    tagline: "Legal Workflow Automation",
    primary: "#6366F1",
    secondary: "#4F46E5",
    accent: "#4338CA",
    gradient: "linear-gradient(135deg, #4F46E5 0%, #2563EB 100%)",
    heroImage: "https://images.unsplash.com/photo-1759724369762-376e0a29478b"
  }
};

const BrandContext = createContext(undefined);

export const BrandProvider = ({ children }) => {
  const [currentBrand, setCurrentBrand] = useState(BRANDS["saketh.ai"]);

  useEffect(() => {
    document.documentElement.style.setProperty('--brand-primary', currentBrand.primary);
    document.documentElement.style.setProperty('--brand-secondary', currentBrand.secondary);
    document.documentElement.style.setProperty('--brand-accent', currentBrand.accent);
  }, [currentBrand]);

  const switchBrand = (brandId) => {
    if (BRANDS[brandId]) {
      setCurrentBrand(BRANDS[brandId]);
    }
  };

  return (
    <BrandContext.Provider value={{ currentBrand, switchBrand, brands: BRANDS }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return context;
};

export { BRANDS };
